export default {
	name: 'bookMangmentImage',
	data() {
		return {
			Customer: [],
			searchText: '',
			Edit: '',
			vipLevl: '',
			CustomerID: 0,
			CustomerPhone: '',
			CustomerName: '',
			VipBeginDate: '',
			VipEndDate: '',
			VipLevlID: '',
			PayMoney: 0,
			Disbursements: 0,
			Deposit: 100,
			VipLevlIDIndex: 0,
			year: 1,
			OperatorID: this.$store.state.user.UserID,
			CustomerQRcode: '',
			now: new Date(),
			getData: '',
			clear: {},
			pageIndex: 1,
			pageRows: 5,
			count: 0,
			boxMoney: 0,
			CustomerChild: 1,
			age: 0,
			school: '',
			BelongTo: this.$store.state.user.UserName,
			Shop: this.$store.state.shop.filter(x => x.areaID == this.areaID),
			ShopID: this.$store.state.user.ShopID,
			selectShopID: this.$store.state.user.ShopID,
			areaID: this.$store.state.user.areaID,

		};
	},
	created() {
		this.areaID = this.$store.state.user.areaID;
		this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
		//this.BooksID = this.$route.params.booksID;
		this.VipBeginDate = this.now.getFullYear() + '-' + (this.now.getMonth() + 101).toString().substr(1) +
			'-' + (this.now.getDate() + 100).toString().substr(1);
		this.VipEndDate = (this.now.getFullYear() + this.year) + '-' + (this.now.getMonth() + 101).toString().substr(
				1) +
			'-' + (this.now.getDate() + 100).toString().substr(1);
		this.getData = function() {
			this.$request.request({
				url: 'Customer/getCustomer',
				data: {
					searchText: this.searchText,
					pageIndex: this.pageIndex,
					pageCount: this.pageRows,
					ShopID: this.selectShopID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.Customer = res.customers;
					this.count = res.count;
					if (this.Customer.length > 0 && this.searchText.length > 11)
						this.searchText = this.Customer[0].CustomerPhone;


				} else {
					this.$uil.showMessage({
						text: res.message
					});
					this.searchText = '';
				}
			});
		}
		this.$request.request({
			url: 'Customer/getVipLevl',
			data: {},
			method: 'post'
		}).then(res => {
			if (res.result) {
				this.vipLevl = res.vipLevl;
				this.vipLevlID = this.vipLevl[this.VipLevlIDIndex].VipLevlID;
				this.PayMoney = this.vipLevl[this.VipLevlIDIndex].Price * this.year;
				this.Disbursements = this.vipLevl[this.VipLevlIDIndex].Price * this.year;
				this.getData();
			}
		});
		this.clear = function() {
			this.VipLevlIDIndex = 0;
			this.vipLevlID = this.vipLevl[this.VipLevlIDIndex].vipLevlID;
			this.PayMoney = this.vipLevl[this.VipLevlIDIndex].Price * this.year;
			this.Disbursements = this.vipLevl[this.VipLevlIDIndex].Price * this.year;
			this.CustomerID = 0;
			this.CustomerPhone = '';
			this.CustomerName = '';
			this.VipEndDate = (this.now.getFullYear() + this.year) + '-' + (this.now.getMonth() + 101).toString()
				.substr(1) +
				'-' + (this.now.getDate() + 100).toString().substr(1);
			this.CustomerQRcode = '';
		}
	},
	methods: {
		resetPWD(i) {
			this.$uil.showMessage({
				type: 'confirm',
				text: '确定重置密码?',
				ok: () => {
					this.$request.request({
						url: 'Customer/restPWD',
						data: {
							CustomerID: i.CustomerID
						},
						method: 'post'
					}).then(res => {
						this.$uil.showMessage({
							text: res.message
						});
					});
				}
			})



		},
		selectArea() {
			this.Shop = this.$store.state.shop.filter(x => x.areaID == this.areaID);
			this.count = 0;
			this.books = [];

			if (this.Shop.length > 0) {
				this.selectShopID = this.Shop[0].ShopID;
				this.pageIndex = 1;
				this.getData();
			}
		},
		exportExce() {

			this.$request.request({
				url: 'Customer/ExportExcel',
				data: {
					ShopID: this.selectShopID
				},
				method: 'post'
			}).then(res => {
				if (res.result)
					window.open(this.$store.state.baseURL.replace("api/", "") + "/" + res.fileglobal);
			});
		},

		hideCode() {
			this.CustomerQRcode = '';
			this.Edit = '';
		},
		searchCustomers(e) {

			if (e.keyCode == 13)
				this.getData();
		},
		selectVipLevl() {
			this.PayMoney = this.vipLevl[this.VipLevlIDIndex].Price * this.year * this.CustomerChild;
			this.Disbursements = this.vipLevl[this.VipLevlIDIndex].Price * this.year * this.CustomerChild;
		},
		changyear(s) {
			if (s == '-') {
				if (this.year == 1) return;
				this.year--;
			} else {
				if (this.year == 5) return;
				this.year++;
			}
			this.PayMoney = this.vipLevl[this.VipLevlIDIndex].Price * this.year * this.CustomerChild;
			this.Disbursements = this.vipLevl[this.VipLevlIDIndex].Price * this.year * this.CustomerChild;
			this.VipEndDate = (this.now.getFullYear() + this.year) + '-' + (this.now.getMonth() + 101).toString()
				.substr(1) +
				'-' + (this.now.getDate() + 100).toString().substr(1);
		},
		updateCode(i) {
			this.$request.request({
				url: 'Customer/updateCustomerQrCorde',
				data: {
					CustomerID: i.CustomerID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.getData();
					this.$uil.showMessage({
						text: '更新成功'
					});
				}
			});
		},
		lookCode(i) {
			this.Edit = 'code';
			this.CustomerQRcode = this.$store.state.imageUrlCustomerCode + i.CustomerQRcode;
		},
		editCustomer() {

			this.$request.request({
				url: 'Customer/addCustomer',
				data: {
					ShopID: this.selectShopID,
					CustomerID: this.CustomerID,
					CustomerPhone: this.CustomerPhone,
					CustomerName: this.CustomerName,
					VipBeginDate: this.VipBeginDate,
					VipEndDate: this.VipEndDate,
					VipLevlID: this.vipLevl[this.VipLevlIDIndex].vipLevlID,
					PayMoney: this.PayMoney,
					Disbursements: this.Disbursements,
					Deposit: this.Deposit,
					CustomerState: 0,
					OperatorID: this.OperatorID,
					age: this.age,
					school: this.school,
					CustomerChild: this.CustomerChild,
					boxMoney: this.boxMoney,
					BelongTo: this.BelongTo
				},
				method: 'post'
			}).then(res => {
				this.$uil.showMessage({
					text: res.message
				});
				this.clear();
				this.getData();
			});
			this.clear();
			this.Edit = '';
		},
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;
			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}
			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		checkCustomer() {
			return this.$uil.checkPhone(this.CustomerPhone) && this.$uil.checkchinese(this.CustomerName, 2, 6) && this
				.BelongTo != '';
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		},
		customerCount() {
			if (this.$store.state.user.UserType > 1)
				return "****人";
			else
				return this.count + '人';
		}
	},
	filters: {
		rmb(v) {
			return v + '¥';
		},
		state(v) {
			if (v == 1) return "正常";
			if (v == 2) return "暂停";
			if (v == 3) return "停止";
		}
	},
	activated() {
		this.getData();
	},

	watch: {
		CustomerChild: function(n, o) {
			if (n != o) {
				this.PayMoney = this.vipLevl[this.VipLevlIDIndex].Price * this.year * this.CustomerChild;
				this.Disbursements = this.vipLevl[this.VipLevlIDIndex].Price * this.year * this.CustomerChild;
			}


		}
	}


}
